import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { DataRequestsState } from '@/types/dataRequestsState';
import { PageList } from '@/types/list';
import {
  MyClaimsListNormalizedResponse,
  MyClaimsListResponse,
} from '@/domains/claims/types/responses/getMyClaimsListResponse';
import PaginationService from '@/services/PaginationService/PaginationService';

export type ClaimsState = {
  myClaimsListData: MyClaimsListNormalizedResponse['claimsPagination'] | null;
  myClaimsListTabCounters: MyClaimsListNormalizedResponse['counters'];
  myClaimsListPagination: PageList;
  dataRequestsStates: {
    myClaimsListData: DataRequestsState;
  };
};

const initialState: ClaimsState = {
  myClaimsListData: null,
  myClaimsListTabCounters: {
    claimsAllMyCounter: 0,
    allClaimsCounter: 0,
  },
  myClaimsListPagination: {
    page: 1,
    perPage: 20,
  },
  dataRequestsStates: {
    myClaimsListData: {
      isLoading: false,
      isFetching: false,
      isSuccess: false,
      isError: false,
    },
  },
};

const claimsSlice = createSlice({
  name: 'claims',
  initialState: initialState,
  reducers: {
    incrementMyClaimsListPage: (state) => {
      state.myClaimsListPagination.page++;
    },
    resetMyClaimsListPage: (state) => {
      state.myClaimsListPagination.page = 1;
    },
    getMyClaimsList(state) {
      state.dataRequestsStates.myClaimsListData = {
        isLoading: true,
        isFetching: !state.dataRequestsStates.myClaimsListData,
        isError: false,
        isSuccess: false,
      };
    },
    getMyClaimsListSuccess(state, action: PayloadAction<MyClaimsListResponse>) {
      state.dataRequestsStates.myClaimsListData = {
        isLoading: false,
        isFetching: false,
        isError: false,
        isSuccess: true,
      };

      state.myClaimsListTabCounters = action.payload.counters;

      const normalizedMyClaimsListResponse = PaginationService.normalizePaginatedListResponse(
        action.payload.claimsPagination,
      );

      if (normalizedMyClaimsListResponse.pagination.page === 1 || !state.myClaimsListData) {
        state.myClaimsListData = normalizedMyClaimsListResponse;
      } else {
        state.myClaimsListData = {
          dataList: state.myClaimsListData.dataList.concat(normalizedMyClaimsListResponse.dataList),
          pagination: normalizedMyClaimsListResponse.pagination,
        };
      }
    },
  },
});

export const { getMyClaimsList, getMyClaimsListSuccess, incrementMyClaimsListPage, resetMyClaimsListPage } =
  claimsSlice.actions;

export const claimsReducer = claimsSlice.reducer;
export const claimsReducerPath = claimsSlice.reducerPath;
